module.exports = __webpack_public_path__ + "static/media/businesslunch-catering-4.bfa3dd93.jpg";